module.exports = __webpack_public_path__ + "img/a011_7.7589c537.png";